import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from '../../utils/HelperFunctions';

class StaticPage extends Component {
    constructor(props) {
        super(props);

        this.closeStaticPage = this.closeStaticPage.bind(this);
    }

    closeStaticPage() {
        const { close } = this.props;

        if (close) {
            close();
        }
    }

    render() {
        const { title, text, t } = this.props;

        return (
            <div className='static-page-wrapper'>
                <div className='static-page-div'>
                    <p className='static-page-title'>{title}</p>
                    <p className='static-page-text'>{text}</p>
                    <button
                        className='btn btn-static-cancel'
                        onClick={this.closeStaticPage}
                    >
                        {t('ok')}
                    </button>
                </div>
            </div>
        )
    }
}

export default withTranslation()(withRouter(StaticPage));